import React, {useEffect, useState} from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'

import Logo from '../images/logo.svg'
import Brandname from '../images/forwalk.svg'
import MenuIcon from '../icons/menu.svg'
import BackIcon from '../icons/prev.svg'

import settings from '../conf'
import { usePathname } from '../hooks'
import { showSidebar, setInfoPanel, useHaveInfoPanel, showMapPanel, useHaveMapPanel  } from '../slices/ui'
import { GO_BACK, MENU } from '../trans'

const HOME_PATHNAME = '/'

const BackButton = (props) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const pathname = usePathname()
  const haveInfoPanel = useHaveInfoPanel() 
  const haveMapPanel = useHaveMapPanel() 

  if (pathname == HOME_PATHNAME) return null 

  const callback = () => {
    if (haveInfoPanel) {
      dispatch(setInfoPanel(null))
      return
    }
    if (haveMapPanel) {
      dispatch(showMapPanel(false))
      return
    }
    history.push({
      pathname: new URL('../', new URL(window.location)).pathname.replace(settings.BASE_NAME, '/'),
      state: Object.assign({}, history.state, {dirty: true})
    })
  }

  return (
    <button className="header__button header__back__button button secondary"
      onClick={callback}
      tabIndex={0}
      role="button">
      <BackIcon/>
      <span className="header__button__label">
        { GO_BACK }
      </span>
    </button>
  )
}

const Header = (props) => {
  const dispatch = useDispatch()
  const { className="" } = props

  return (
    <div className={ className + " header"} role="presentation">
      <div className="header__container" role="presentation">
        <div className="header__container__inner" role="presentation">

          <div className="header__leftmenu" role="presentation">
            <BackButton/>
          </div>

          <div className="header__logocontainer"
               role="presentation">

            <a className="header__logo"
               href={settings.HOME_URL}>
              <Logo/>
            </a>

            <div className="header__brandname">
              <Brandname/>
            </div>
          </div>

          <div className="header__rightmenu" role="presentation">
            <button className="header__button button secondary"
              onClick={() => dispatch(showSidebar('menu'))}
              tabIndex={0}>
              <MenuIcon/>
              <span className="header__button__label">
                { MENU }
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Header
